// extracted by mini-css-extract-plugin
module.exports = {"theme":"#1890ff","menutext":"#bfcbd9","menuactivetext":"#409eff","submenuactivetext":"#f4f4f5","menubg":"#304156","menuhover":"#263445","submenubg":"#1f2d3d","submenuhover":"#001528","sidebarwidth":"210px"};
    if(module.hot) {
      // 1792641758392
      var cssReload = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  